import { Component } from '@angular/core';

/**
 * Empty shell component — no logic, inputs, outputs, or lifecycle hooks implemented.
 * Intended as a parent container for a products list; content not yet built out.
 */
@Component({
  selector: 'app-list-products-parent',
  templateUrl: './list-products-parent.component.html',
  styleUrl: './list-products-parent.component.css'
})
export class ListProductsParentComponent {

}
